export default {"src":"/_next/static/media/nature.7225ee8f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};